import { render, staticRenderFns } from "./ReferralInformation.vue?vue&type=template&id=7852a144&scoped=true"
import script from "./ReferralInformation.vue?vue&type=script&lang=js"
export * from "./ReferralInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7852a144",
  null
  
)

export default component.exports